import { Tooltip } from '@material-ui/core';
import { Body } from 'copilot-design-system';
import React from 'react';

export const PreviewTooltip: React.FC<{
  label: string;
}> = ({ children, label }) => {
  return (
    <Tooltip
      classes={{
        tooltip: 'bg-white border-gray-300 px-2 py-[2px]',
      }}
      interactive
      title={
        <Body size="xs" className="text-secondary">
          {label}
        </Body>
      }
    >
      <div>{children}</div>
    </Tooltip>
  );
};
